import { render, staticRenderFns } from "./error-detail.vue?vue&type=template&id=48b9bd76&scoped=true&"
import script from "./error-detail.vue?vue&type=script&lang=js&"
export * from "./error-detail.vue?vue&type=script&lang=js&"
import style0 from "./error-detail.vue?vue&type=style&index=0&id=48b9bd76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9bd76",
  null
  
)

export default component.exports